import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    resources: {
      en: {
        translations: {
          WHO_WOULD_YOU_LIKE_TO_INSURANCE: "Who would you like to insure?",
          "EMAIL": "Email",
          COVER: "Cover",
          PAYMENT_TERM: "Payment Term",
          "Male": "Male",
          "Female": "Female",
          AFFORDABLE_CONTRIBUTIONS: "Affordable contributions",
          Motor: 'Motor',
          HELP: "Help",
          Male: 'Male',
          Female: "Female",
          Gender: 'Gender',
          EDIT: 'Edit',
          COMPARE: 'COMPARE',
          SHOWING_PLANS_FOR: 'Showing plans For',
          MODE: 'Mode',
          TOTAL: "Total contribution",
          CURRENCY: 'Currency',
          INSURED_DETAILS: 'Insured details',
          CompanyName: 'Company name',
          "Company Name": "Company Name",
          PLACEHOLDER_RTO_CODE: "RTO Code",
          CHOOSE_RIDERS: 'Choose Riders',
          CHECK_PRODUCT_DETAILS: "Check product details",
          ANNUAL_INCOME_AED: 'Annual Income',
          COVERAGE: 'Coverage',
          TERM: 'Term',
          KNOW_MORE: 'Know more',
          FILTER_SEARCH: 'Show Deals',
          FILTER: 'Filter',
          YES: 'Yes',
          NO: 'No',
          ADD: "Add",
          ADD_RIDER: "Add Rider",
          CANCEL: 'Cancel',
          PAGE_BACK_BTN: 'Back',
          Verify_Details: 'Verify Details',
          OtpSentToMobile: 'OTP Sent to Mobile',
          REVIEW_DETAILS: "Review Details",
          ADDRESS_DETAILS: "Address Details",
          PAY_NOW: "Pay now",
          STATUS: "Status:",
          civilId: "Civil Id",
          licenseID: "license Id",
          APPROVED_BY_UNDERWRITER: "Approved by underwriter",
          PAYMENT_SUCCESSFUL: "Payment successful!",
          CONTINUE: "Continue",
          ADD_FAMILY_MEMBER_BTN: "+ Add member",
          RETRY: "Retry",
          THANK_YOU: "Thank you!",
          SUM_ASSURED: "Sum Assured",
          PREMIUM: "Premium",
          ORDER_STATUS: "Order status",
          CLEAR: "Clear",
          SAVE: "Save",
          SORRY: "Sorry!",
          DONT_HAVE_PLANS: "We don't have plans based on your criteria.",
          GO_BACK: "Go Back",
          TERMINAL_ILLNESS_BENEFIT: "Terminal illness benefit",
          PLAN_FEATURES: "Plan Features",
          POLICY_TERM: "Policy Term",
          WHAT_YOU_GET: "What You Get",
          DOCUMENTS: "Documents",
          FAQ: "FAQ's",
          FIRST_NAME: "First Name",
          MIDDLE_NAME: "Middle Name",
          LAST_NAME: "Last Name",
          COUNTRY_OF_BIRTH: "Country Of Birth",
          PASSPORT_ID_NO: "Passport No.",
          MARITAL_STATUS: "Marital Status",
          NATIONALITY: "Nationality",
          BENEFICIARY_NAME: "Beneficiary Full Name",
          BENEFICIARY_MIDDLE_NAME: "Beneficiary middle name",
          BENEFICIARY_LAST_NAME: "Beneficiary last name",
          STATUS: "Status",
          SUM_OF_COVERED: "Sum Of Covered",
          TYPE_OF_COVERAGE: "Type Of Coverage",
          RELATIONSHIP: "Relationship",
          ALLOCATION_PER: "Allocation %",
          ASSIGNEE_ADDRESS: "Assignee Address",
          GUARDIAN_NAME: "Guardian Full Name",
          RELATIONSHIP_TO_BENEFICIARY: "Relationship To Beneficiary (ies)",
          ID_PASSPORT_NO: "ID / Passport No.",
          UPLOAD_DOCUMENT: "Upload document",
          PAYMENT_OPTION: "Please select your preferred payment option",
          STANDING_INSTRUCTION: "Set up standing instructions and auto-pay for future installments automatically on their due dates.",
          CREDIT_DISCLAIMER: "I, the card member named hereunder, authorize payment of all Contributions in respect of this proposal and subsequent payments at the frequency stated herein to be made through my credit card.",
          ALLOWED_DISCLAIMER: "**Allowed for the card holder, his / her spouse, parent and / or children’s contribution only",
          DISCLAIMER_ERROR: "Please accept the declaration",
          CASH: "Cash",
          CREDIT_CARD: "Debit/ Credit Card",
          AT_BRANCH: "Bank Transfer",
          OCCUPATION: "Occupation",
          BANKNAME: "Loan issuing Bank",
          OTHER_OCCUPATION: "Occupation Name",
          ONLINE: "Online",
          CHEQUE: "Cheque",
          OTHERS: "Others",
          DOCUMENT_UPLOAD: "Document Upload",
          DOWNLOADS_TITLE: "Downloads",
          DOCUMENT_TYPE: "Document Type",
          BROWSE: "Browse",
          PLUS_ADD: "+ Add",
          ORDER_ID: "Order ID :",
          TRANSACTION_ID: "Transaction ID",
          REFERENCE_NO: 'Reference number',
          AMOUNT: "Amount",
          MEMBER: 'Member',
          ADD_FAMILY_MEMBER: "+ Add Family Member",
          FAMILY_HISTORY: "Family History",
          HEALTH_STATUS: "Vital Status",
          CURRENT_AGE: "Current Age",
          AGE_AT_DEATH: "Age at Death",
          CAUSE_OF_DEATH: "Cause Of Death",
          STATE_OF_HEALTH: "State Of Vital",
          ADD_FAMILY_MEMBER_MODAL: "Add Family Member",
          FATHER: "Father",
          MOTHER: "Mother",
          BROTHER: "Brother",
          SISTER: "Sister",
          DOWNLOAD: "Download",
          DOWNLOAD_BENEFIT_ILLUSTRATION: "Click here to download benefit illustration",
          MIN_MAX_ENTRY_AGE: "Min./Max. Entry Age",
          MIN_MAX_PAYMENT_TERM: "Min./Max. payment term",
          MIN_CONTRIBUTION: "Min. Contribution",
          MAX_LIFE_COVER: "Max. Life Cover",
          MIN_LIFE_COVER: "Min. Life Cover",
          GEOGRAPHIC_COVERAGE: "Geographic Coverage",
          FREE_LOOK_PERIOD: "Free Look Period",
          GRACE_PERIOD: "Grace Period",
          WHAT_COVERED: "What's Covered",
          WHAT_NOT_COVERED: "What's Not Covered",
          LIFESTYLE_QUESTIONNAIRE: "Lifestyle Questionnaire",
          DO_YOU_SOMKE: "Do you smoke?",
          TOBACCO_TYPE: "Tobacco Type",
          FREQUENCY: "Frequency",
          QUANTITY: "Quantity",
          ALCOHOL_TYPE: "Alcohol Type",
          FREQUENCY_FOR_ALCOHOL: "Frequency For Alcohol",
          UNITS: "Units",
          PROPOSAL_NUMBER: "Proposal number",
          ADDON_TITLE: "Add-Ons",
          YES_SMOKE: "Yes, I smoke",
          CONSUME_ALCOHOL: "Yes, I consume alchohol",
          USING_DRUG: "Are you currently using any drugs?",
          YES_USING_DRUG: "Yes",
          ARMED_FORCE_MEMBER: "Member of any armed forces?",
          YES_ARMED_FORCE_MEMBER: "Yes, I am a member of armed forced",
          IN_2YEAR_TRAVELED_OUTSIDE: "In the past 2 years, have you traveled outside the country?",
          YES_TRAVELD: "Yes, I have travelled outside the country",
          ANY_CONFIRMED_TRAVEL_PLAN: "In the next 12 months, do you have any confirmed travel plans?",
          YES_HAVE_PLAN_FOR_GOING_OUTSIDE_COUNTRY: "Yes, I have plans to travel outside the country",
          ENGAEGED_IN_PRIVATE_FLYING: "Have you ever engaged in any private flying or hazardous sports?",
          YES_ENGAGED_IN_PRIVATE_FLYING: "Yes, I have engaged in hazardous sports or racing activities",
          WEIGHT_CHANGED: "Has your weight changed by more than 5kg in the past year?",
          YES_WEIGHT_CHANGED: "Yes, My weight has changed by more than 5Kg in the past year",
          HAS_ANY_APPLICATION_FOR_FAMITY: "Has any of your applications, renewals or reinstatements for family?",
          YES_HAS_APPLICATION: "yes",
          HAS_ANY_INSURANCE_CLAIM: "Has any takaful/insurance claim ever been submitted by you?",
          YES_INSURANCE_CLAIM: "Yes, claim has been submitted",
          SIGN_OUT: "Sign out",
          LOGIN: "Login",
          SIGNATURE: "SIGNATURE:",
          Employers_Name: "Employers name",
          TYPE_OF_BENEFICIARY: "Type Of Beneficiary",
          NOT_SURE_GET_OUR_RECOMMENDATION: "Not sure? Get our recommendation of your insurance needs",
          LANDING_BACK: "Back",
          DETAILS_OF_TOTAL_LIABILITIES: "Details of total liabilities",
          SOURCE_OF_FUND_INVESTED: "Sources of funds to be invested",
          ACCOUNT_DETAILS: "Account details",
          REALESTATE: 'Real estate',
          STOCKS_AND_BONDS: "Stock & bonds",
          EMIRATESID: "Emirates ID",
          FULLNAME: "Full Name",
          YOU_DO_NOT_HAVE_ANY_PREVIOUS_POLICY: "You don't have any previous policy",
          PRE_EXISTING_DISEASES_DECLARED: "Pre existing diseases declared.",
          NOT_SUFFERING_FROM_ANY_DISEASE: "Not suffering from any disease",
          YOU_HAVE_NOT_DECLARED_ANY_HEALTH_TRAVEL_CONDITIONS: "Not declared any health and travel conditions",
          YOU_HAVE_NOT_DECLARED_ANY_LIFESTYLE_CONDITIONS: "You have not declared any lifestyle conditions",
          TOTAL_ASSETS: "Details of total assets:",
          TOTAL_LIABILITIES: "Total Liabilities:",
          DEBT_ACCOUNT: "Debt Account:",
          FOR_FURTHER_QUERIES_AND_ASSISTANCE: "For further queries and assistance",
          FATCA_AND_CRS_DATA: "FATCA and CRS Data",
          FATCA_and_CRS: "FATCA and CRS",
          GO_TO_MY_ACCOUNT: "Go to my account",
          GO_TO_MY_DASHBOARD: "Go to dashboard",
          GO_TO_HOME: "Go to home",
          SUCCESS: "Success!",
          SUCCESSFULLY_SUBMITTED: "Your endorsement request has been successfully submitted.",
          HOME: "Home",
          YOU_CAN_ALSO_CHECK_THE_PROPOSAL_STATIS_IN_YOUR_ACCOUNT: "You can also check the proposal status in your account.",
          BROCHURES: "Brochures",
          DOCUMENT_BROCHURE_TXT: "Brochure",
          CLAIM_FORMS: "Claim Forms",
          SERVICING_FORMS: "Servicing Forms",
          OTHER_DOCUMENTS: "Other Documents",
          QUESTIONNAIRE: "Questionnaire",
          LIFE_PURE_PROTECTION: "Life pure protection",
          CHANGE_OF_ADDRESS_FORM: "Change of address form",
          DEATH_CLAIM_FORM_A_CLAIMANT_STATEMENT_RB: "Death claim - form a claimant Statement RB",
          DEATH_CLAIM_FORM_B_ATTENDING_PHYSICIANS_STATEMENT: "Death claim - form b attending physician's statement",
          DEATH_CLAIM_FORM_C_EMPLOYER_STATEMENT: "Death claim - form c employer statement",
          LIFE_SMART_SAVE: "Life smart save",
          PROPOSER_DONE: "Proposer  (DONE)",
          LIFE_ASSURED_DONE: "Life assured / Insured  (DONE)",
          WITHNESS_DONE: "Witness  (DONE)",
          AGENT_DONE: "Agent  (DONE)",
          PLEASE_ADD_SIGNATURE: "Please add signatures of",
          INSURED: "Insured",
          CLICK_HERE_TO_EDIT: "Click here to re-sign",
          PROPOSER: "Proposer",
          LIFE_ASSURED_INSURED: "Life Assured / Insured",
          LIFE_ASSURED_INSURED2: "Life Assured / Insured 2",
          WITNESS: "Witness",
          AGENT_SIGNATURE: "Agent Signature",
          SURE_TO_SUBMIT_PROPOSER: "Are you sure you wish to submit the proposal?",
          PLEASE_NOTE_AFTER_SUBMISSION_YOU_CANNOT_EDIT: "Please note that you cannot make edits to the form after submission.",
          Share_The_Link: "Share the link with the customer",
          GO_TO_DASHBOARD: "Go to my dashboard",
          Link_successfully: "Link has been successfully shared to customer",
          AGENT_CODE: "AGENT CODE",
          ENTER_YOUR_AGENT_CODE_FOR_REFERRAL_COMMISSION: "Enter your agent code & branch for referral commission",
          YES_PROCEEE: "Yes, Proceed",
          NO_CANCEL: "No, Cancel",
          AGGENT_CHECK_ONE_DECS: "I declare that I have met/spoken with the customer and explained all the contents of this proposal form, including the nature of the questions contained in this proposal form in vernacular language known to him/her and policy is being sold in line with his/her requirement.",
          AGGENT_CHECK_TWO_DECS: "I have also explained that the statement(s), information and response(s) submitted by him / her in this proposal form to questions contained herein or any details sought herein will form the basis of the contract of insurance between the Company and the proposer, if this proposal is accepted by the Company for issuance of a policy. I am satisfied with the identity of this Prospect(s) and I recommend to consider the above mentioned information on the Prospect(s) by the Company.",
          AGGENT_CHECK_THREE_DECS: " I, Venky Immidi, SP Code 00005 (Watania Takaful), agree that I have read the application form, do hereby confirm and submit the information above. Further, I understand and confirm to be bound by submission.",
          MY_ACCOUNT: "My Account",
          MY_DASHBOARD: "My Dashboard",
          CHANGE_SUM_ASSURED: "Change sum assured",
          EXISTING_SUM_ASSURED: "Existing Sum Assured",
          SUM_ASSURED: "Sum Assured",
          TENURE: "Tenure",
          UPDATED_CONTRIBUTION: "Updated contribution",
          PREVIOUS_CURRENT_ADDRESS: "Previous current address",
          PREVIOUS_PERMANENT_ADDRESS: "Previous permanent address",
          CANCEL_POLICY: "Cancel Policy",
          FREE_LOOK_CANCELLATION: "Free look cancellation",
          REINSTATE_POLICY: "Reinstate Policy",
          PAYMENT_DUE: "Payment Due",
          CONTRIBUTION_ID: "Contribution ID",
          TOTAL_PREMIUM_CONTRIBUTION_DUE: "Total Premium Contribution Due",
          DUE_DATE: "Due Date",
          TRAVEL_DETAILS: 'Travel info',
          NAME_OF_COUNTRY: 'Name of the Country',
          DATE_DEPARTED: 'Date of departed',
          DATE_ARRIVED: 'Date of arrived',
          REASON_FOR_TRAVEL: 'Reason for travel',
          NAME_OF_THE_BANK: "Name of the Bank",
          ACCOUNT_NUMBER: "Account Number",
          ACCOUNT_NAME: "Account Name",
          IBAN_NUMBER: "Swift Code/ IBAN no.",
          BANK_ADDRESS: "Bank Address",
          ARMED_FORCES_QUESTIONNAIRE: "Armed forces questionnaire",
          FINANCIAL_QUESTIONNAIRE: "Financial questionnaire",
          OVERSEAS_TRAVEL_AND_RESIDENCE_QUESTIONNAIRE: "Overseas travel and residence questionnaire",
          CHEST_PAIN_QUESTIONNAIRE: "Chest pain questionnaire",
          DIABETES_MELLITUS_QUESTIONNAIRE: "Diabetes mellitus questionnaire",
          KEYMAN_AND_BUSINESS_COVER_QUESTIONNAIRE: "Keyman and business cover questionnaire",
          FATCA_KYC_FORM_US_NATIONAL: "FATCA KYC form US National",
          STATEMENT_OF_GOOD_HEALTH: "Statement of good health",
          W9_FORM: "W9 Form",
          CONFIRM_QUOTATION: "Confirm Quotation",
          CONFIRM_QUOTATION_MESS: "Are you sure you want to accept this quotation? You can either confirm the quotation to proceed with the proposal or modify the quotation.",
          ACCEPT_BUTTON: "Accept",
          MODIFY_BUTTON: "Modify",
          DECLARATION_BENEFIT_ILLUSTRATION: "Declaration - Benefit Illustration",
          DECLARATION_DESCRIPTION_TXT: "I understand that the benefit illustration is for illustrative purposes only and does not constitute a contract or offer to sell insurance. I further understand that the final terms of the policy will be determined based on the actual policy contract issued by the insurance company. By accepting this declaration, I confirm that I have read, understood, and agree to abide by the terms stated herein.",
          PremiumContribution: "Contribution",
          CHOOSE_FUNDS_TITLE: "Choose Funds",
          FUND_ALLOCATION_TITLE: "Fund Allocation",
          DOWNLOAD_PERFORMANCE_SHEET: "Download Performance Sheet",
          INVEST_FOR: "Invest For",
          TOTAL_FUND_ALLOCATION: "Total Fund Allocation",
          FUND_ALLOCATION: "Fund Allocation (%)",
          LAST_UPDATED: "Last Updated NAV",
          FUND_CATEGORY: "Fund Category",
          BANK_NAME: "Bank Name",
          ACCOUNT_TYPE: "Account Type",
          ACCOUNT_CURRENCY_TYPE: "Account Currency Type",
          FIRST_YEAR_INCOME: "First Year Income",
          SECOND_YEAR_INCOME: "Second Year Income",
          THIRD_YEAR_INCOME: "Third Year Income",
          SHORT_TERM_LOANS: "Short Term Loans",
          LONG_TERM_LOANS: "Long Term Loans",
          OTHER_LOANS: "Other Loans",
          TOTAL_LIABILITIES: "Total Liabilities",
          YOU_DONT_HAVE_ANY_PREVIOUS_POLICY: "You don't have any previous policy",
          YOUR_CUSTOMER_DOESNT_HAVE_ANY_PREVIOUS_POLICIES: "Your customer doesn't have any previous policies.",
          //Home page starts here
          HM_ONIC_GROUP_COMPANY: "ONEIC Group Company",
          HM_GET_INSURANCE_STEPS: "Get your insurance in 3 easy steps",
          HM_MORE: "More",
          HM_SAVINGS: "Savings",
          HM_MORE_CONVENIENCE_TXT: "& More Convenience for You!",
          HM_START_YOUR_JOURNEY: "Start your journey",
          HM_PROVIDE_US_THE_DETAILS_TXT: "Provide us the details for insurance and leave the rest to us.",
          HM_COMPARE_CHOOSE: "Compare and Choose",
          HM_WE_BRING_THE_BEST_TXT: "We bring you the best online insurance to compare & choose",
          HM_FAST_POLICY_INSURANCE: "Fast policy issuance to save your time and money.",
          HM_REQUEST_CALL_BUTTON: "Request a call back",
          HM_INSURANCE_PARTNER_TXT: "Our Insurance Partners",

          // MOTOR ENGLISH LANGUAGE KEYS STARTS HERE 
          GREAT: "Great",
          CHOICE: "Choice!",
          NOW_ENTER_YOUR_DETAILS: "Instant Insurance & More ",
          SAVINGS: "Savings",
          ENTER_YOUR_CAR_OR_MOTORCYCLE_PLATE_NUMBER: "Enter your car or motorcycle plate number",
          ENTER_DRIVER_DETAILS: "Enter Driver details...",
          NAME: "Name *",
          LICENSE_NUMBER: "license number",
          MOBILE_NUMBER: "Your Mobile number",
          POLICY_TYPE_LABEL_TXT: "Policy Type",
          NEW_CAR_CONTINUE_WITHOUT_CAR_NUMBER: "New Car? Continue without car number",
          BY_PROCEEDING_YOU_AGREE: 'By proceeding, you agree to Tameen’s',
          PRIVACY_POLICY: ' Privacy Policy',
          NOT_NEW_CAR: "Not a New Car?",
          DRIVING_EXPERIENCE: "Driving Experience",
          NOT_A_NEW_CAR: "Not a New Car?",
          GET_MOTOR: "Get Motor",
          OFFERS: "Offers",
          WHICH_PLAN_ARE_YOU_LOOKING_FOR: "Which plan are you looking for?",
          BUY: "Buy",
          THIRD_PARTY: "third party",
          COMPREHENSIVE: "Comprehensive",
          HOME_BUTTON_THIRD_PARTY: "Third party Insurance",
          HOME_BUTTON_COMPREHENSIVE: "Comprehensive / Full Insurance",
          WHAT_IS_THE_DIFFERENCE_BETWEEN_THIRD_PARTY_AND_COMPREHENSIVE_INSURANCE: "What is the difference between third party and comprehensive insurance?",
          WHAT_IS_YOUR_VEHICLE_VALUE: "What is your vehicle value?",
          ENSURE_ACCURATE_COVERAGE_FOR_YOUR_CAR: "Ensure accurate coverage for your car",
          VALUE_IN_RO: "Value in RO",
          MAKE_SURE_THE_CAR_VALUE_YOU_ENTERED_MATCHES_THE_MARKET_PRICE_OR_BASED_ON_THE_PREVIOUS_POLICY: "",
          COMPREHENSIVE: "Comprehensive",
          VEHICLE_VALUE: "Vehicle Value",
          CONFIRM_YOUR: "Confirm Your",
          YES_PROCEED: "Yes, Proceed",
          BUY_NOW: "BUY NOW",
          MOTOR_VIEW_BREAKUP: "View Breakup",
          YOUR_NEW_POLICY_WILL_START_ON: "Your new policy will start on",
          LANDING_GET_EASY_SUB_TXT: 'Get easy, quick insurance and compare different offers from different providers',
          LANDING_CARDS_MOTOR_INSURANCE_TITLE: 'Motor Insurance',
          LANDING_CARDS_CREDIT_INSURANCE_TITLE: "Credit Life Insurance",
          LANDING_CARDS_TRAVEL_DOMESTIC_INSURANCE_TITLE: "Domestic Helper Insurance",
          LANDING_PAGE_TITLE_NEW_AGE_PARTNER: 'New-age partner for all your',
          LANDING_PAGE_TITLE_INSURANCE: "Insurance",
          LANDING_PAGE_TITLE_NEEDS_TXT: 'needs',
          HELP_MODAL_SUPPORT_EMAIL: "support@tameen.om",
          MODAL_SUPPORT_NUMBER: "+968 2223456",
          ADDON_TYPE_LABEL: "Type",
          ADDON_LEFT_LABEL: "Addon",
          ADDON_ADD_BUTTON: "ADD",
          ADDON_REMOVE_BUTTON: "REMOVE",
          ADDITIONAL_DRIVERS: "Additional Drivers",
          MOTOR_ADD_VEHICLE_OWNERS_NAME: "Vehicle Owner & Additional Drivers",
          VEHICLE_DETAILS: "",
          DRIVER_DETAILS: "Driver Details",
          SUMMARY_AGE_LABEL: "Age",
          SUMMARY_TOTAL_AMOUNT_RO: "Total Amount Ro",
          SUMMARY_ORDERID: "Order Id",
          SUMMARY_BY_CONTINUING_YOU_AGREE_TO_OUR: "by continuing  you agree to our",
          SUMMARY_TERMS_CONDITIONS: "Terms & Conditions",
          SUMMARY_PROPOSAL_FORM: "Proposal Form",
          SUMMARY_DOCUMENT_1_LABEL: "Document - 1",
          SUMMARY_DOCUMENT_2_LABEL: "Document - 2",
          SUMMARY_DOCUMENT_3_LABEL: "Document - 3",
          FULL_NAME_OF_VEHICLE_OWNER: "Full name of vehicle owner",
          LICENSE_NUMBER: "Resident Card / License Number",
          QUICK_TIP: "Quick tip",
          QUICK_TIP_DEC: "Adding additional drivers to the policy is not mandatory, and 25 RO discount while opening the claim form only.",
          TRAVEL_TIP_DEC: "This covers your single international trip with multiple destinations",

          MOTOR_PLEASE_SELECT_DRIVER_OR_ADD_NEW_DRIVER: "Enter Additional Driver Details",
          ENTER_YOUR_NAME: "Enter your name",
          ENTER_YEARS: "Enter years",
          SELECT_BUTTON_TXT: "SELECT",
          RADIO_BUTTON_YES: "Yes",
          RADIO_BUTTON_NO: "No",
          PLACEHOLDER_CHARS: "Plate Code",
          PLACEHOLDER_BAISIC_FORM_VEHICLE_NUMBER: "Plate Number",
          PLACEHOLDER_CODE: "Code",
          PLACEHOLDER_YEAR: "Year",
          RE_SEND_OTP: "RE-SEND-OTP",
          RE_SEND_OTP_MSG: "Resend in 00:",
          TAMEENCOM: "tameen.com ",
          OTP_MOBILE_VERIFICATION_TITLE: "Verification",
          OTP_MOBILE_TITLE_SUB_TXT: "",
          MOTOR_OTP_MOBILE_TITLE_SUB_TXT: "Enter the one-time password (OTP) received on your mobile",
          OTP_SIGNUP_TXT: "By signing up, you agree to our Terms & Conditions and Privacy Policy",
          YOUR_CAR_TITLE: "Your Car",
          DETAILS_TITLE: "Details",
          BEST_DEALS_VALUE_TXT: "Value",
          BEST_DEALS_ADDON_TITLE: "ADD ONS",
          TRY_AGAIN: "Try Again",
          MOTOR_PAYMENT_SUCCESSFUL_MSG_TXT: "Thank you! your payment of  RO 2500 has been received.",
          MOTOR_PAYMENT_CONTACT_MSG_TXT: "Please contact us at XXX- XXXXXX or email to",
          MOTOR_PAYMENT_EMAIL_TXT: "help@tameen.om",
          MOTOR_PAYMENT_CONTACT_QUERY_TXT: "for any query.",
          MOTOR_PAYMENT_FAILED_TITLE_TXT: "Payment Failed!",
          MOTOR_PAYMENT_FAILED_MSG_TXT: "An error occured while processing your payment. Please try again",
          MOTOR_RETRY_PAYMENT_BUTTON: "Retry Payment",
          BASIC_FROM_PROCEED_BTN: 'PROCEED',
          PROCEED: 'PROCEED',
          FIND_MY_POLICY: 'Find My Policy',
          PAY_PROCEED_BTN: "PROCEED",
          SM_HOME: "Home",
          SM_ABOUT_US: "About Us",
          SM_WHAT_WE_ARE: "What we are",
          SM_OUT_TEAM: "Our Team",
          SM_CONTACT_US: "Contact Us",
          SM_FAQS: "FAQ's",
          SM_PRIVACY_POLICY: "Privacy Policy",
          SM_TERMS_AND_CONDITIONS: "Terms & Conditions",
          SM_ACC_PERSONAL_INSURANCE_HD_TXT: "Personal Insurance",
          SM_ACC_MOTOR_INSURANCE: "Motor Insurance",
          SM_ACC_TRAVEL_INSURANCE: "Travel Insurance",
          SM_ACC_HEALTH_INSURANCE: "Health Insurance",
          SM_ACC_HOME_INSURANCE: "Home Insurance",
          SM_ACC_HOUSEMAID_INSURANCE: "Housemaid Insurance",
          SM_ACC_PERSONAL_ACCIDENT_INSURANCE: "Personal Accident Insurance",
          SM_ACC_GOLF_INSURANCE: "Golf Insurance",
          SM_ACC_LIFE_INSURANCE: "Life Insurance",
          SM_ACC_GROUP_EMPLOYEE_INSURANCE_HD_TXT: "Group / Employee Insurance",
          SM_ACC_COMMERCIAL_INSURANCE_HD_TXT: "Commercial Insurance",
          SM_ACC_SPECIALIZED_INSURANCE_HD_TXT: "Specialized Insurance",
          SM_ACC_INSURANCE_SERVICES_HD_TXT: "Insurance Services",

          // TRAVEL HERE
          FLOAT_TRAVELLING_FROM: "Travelling from",
          FLOAT_TRAVELLING_TO: "Travelling to",
          SUMMARY_CONTINUE_PAYMENT_BTN: "CONTINUE TO PAYMENT",

          //FAQ HERE
          FAQ_MOTOR_INSURANCE_PAGE_HEADING: "Motor Insurance",
          FAQ_TRAVEL_INSURANCE_PAGE_HEADING: "Travel Insurance",
          FAQ_HOME_INSURANCE_PAGE_HEADING: "Home Insurance",
          FAQ_LIFE_INSURANCE_PAGE_HEADING: "Life Insurance",
          FAQ_MEDICAL_INSURANCE_PAGE_HEADING: "Medical Insurance",
          FAQ_PROPERTY_INSURANCE_PAGE_HEADING: "Property Insurance",

          //CLAIM ASSISTANCE 
          CLAIM_ASSISTANCE_BANNER_HEADING: "Claims Assistance by Tameen.om",
          CLAIM_PROCESS_ROADSIDE_ASSISTANCE: "Roadside Assistance",
          CLAIM_PROCESS_CUSTOMER_CARE_NO_TITLE: "Customer Care No",
          CLAIM_PROCESS_CLAIMS_REGISTRATION_NO: "Claims Registration No",
          CLAIM_PROCESS_MAIL_ID: "Mail ID",
          CLAIM_PROCESS_ONLINE: "Claims Online",
          CLAIM_PROCESS_CLAIM_INTIMATION: "Claim Intimation",
          CLAIM_PROCESS_CLAIM_PROCESSING: "Claim Processing",
          CLAIM_PROCESS_CLAIM_SETTLEMENT: "Claim Settlement",
          CLAIM_PROCESS_DOCUMENTS_REQUIRED: "Documents Required",
          CLAIM_PROCESS_DROP_OFF: "Drop off",
          CLAIM_PROCESS_REPAIR_ESTIMATE: "Repair estimate",
          CLAIM_PROCESS_VEHICLE_INSPECTION: "Vehicle inspection",
          CLAIM_PROCESS_REPAIR_WORKS: "Repair works",
          CLAIM_PROCESS_WHATSAPP_NO: "WhatsApp No",
          CLAIM_PROCESS_OTHERS: "Others",
          PLEASE_SELECT_INSURER_CNT_DETAILS: "Please select an Insurer to get the contact details",
          CLAIM_PROCESS_NOTE_TXT: "NOTE:",
          DWN_CLAIM_FROM_BTN: "DOWNLOAD CLAIM FORM",

          //MOTOR CLAIM PROCESS
          MOTOR_CLAIM_PROCESS_HEADING: "Motor Claim Process",
          MOTOR_CLAIM_DWN_CLAIM_FROM: "DOWNLOAD MOTOR CLAIM FORM",
          CLAIM_PROCESS_EMAIL: "Mail ID",

          // TRAVEL CLAIM PROCESS
          TRAVEL_CLAIM_PROCESS_HEADING: "Travel Claim Process",
          TRAVEL_CLAIM_DWN_CLAIM_FROM: "DOWNLOAD TRAVEL CLAIM FORM",

          // MEDICAL CLAIM PROCESS
          MEDICAL_CLAIM_PROCESS_HEADING: "Medical Claim Process",
          MEDICAL_CLAIM_DWN_CLAIM_FROM: "Medical Insurance Claims Process",

          // Commercial Insurance English Starts Here
          COMM_INSU_BANNER_TITLE: "Commercial Insurance",
          COMM_INSU_BANNER_REQUES_CALL_BACK_BTN: "Request a call back",
          COMM_INSU_GET_QUOTES_BTN: "Get Quotes",
          //commercial Insurance English Ends Here

          // HEADER ENGLISH STARTS HERE
          HEADER_SLOG_TEXT: "Click - Compare - Save",
          // HEADER ENGLISH ENDS HERE

          //Product Gallery ENGLISH STARTS HERE
          YACHT_INSURANCE: "Yacht Insurance",
          ART_INSURANCE: "Art Insurance",
          RELOCATION_INSURANCE: "Relocation Insurance",
          GOLF_INSURANCE: "Golf Insurance",
          PRODUCT_GALLERY_PROJECT_INSU_TXT: "Project Insurance",
          PRODUCT_GALLERY_BUSINESS_GROUP_POLICY_INSU_TXT: "Business Group Policy Insurance",
          PRODUCT_GALLERY_GROUP_LIFE_INSU_TXT: "Group life Insurance",
          PRODUCT_GALLERY_TERRORISM_POLITICAL_INSU_TXT: "Terrorism and Political Risk Cover Insurance",
          PRODUCT_GALLERY_CYBER_CRIME_INSU_TXT: "Cyber Crime Insurance",
          PRODUCT_GALLERY_ENGINEERIGN_INSU_TXT: "Project Insurance",
          PRODUCT_GALLERY_STOCK_THROUGHPUT_COVER_INSU_TXT: "Stock Throughput Cover Insurance",
          PRODUCT_GALLERY_JEWELERS_BLOCK_INSU_TXT: "Jewelers Block Insurance",
          PRODUCT_GALLERY_WORKMEN_COMPENSATION_INSU_TXT: "Workmen Compensation Insurance",
          PRODUCT_GALLERY_SPECIALTY_RISK_EVENT_INSU_TXT: "Specialty Risk Event Insurance",
          PRODUCT_GALLERY_GROUP_PERSONAL_ACCITENT_INSU_TXT: "Group Personal Accident Insurance",
          PRODUCT_GALLERY_PROPERTY_INSU_TXT: "Property Insurance",
          PRODUCT_GALLERY_GROUP_HEALTH_INSU_TXT: "Group Health Insurance",
          PRODUCT_GALLERY_FIDELITY_GUARANTEE_INSU_TXT: "Fidelity Guarantee Insurance",
          PRODUCT_GALLERY_BURGLARY_INSU_TXT: "Burglary Insurance",
          PRODUCT_GALLERY_LIABILITY_INSU_TXT: "Liability Insurance",
          PRODUCT_GALLERY_MARINE_INSU_TXT: "Transit Insurance",
          PRODUCT_GALLERY_HAULIERS_FULL_VALUE_CARTO_INSU_TXT: "Hauliers Full Value Cargo Cover Insurance",
          PRODUCT_GALLERY_MOTOR_FLEET_INSU_TXT: "Motor Fleet Insurance",
          PRODUCT_GALLERY_ENERGY_INSU_TXT: "Energy Insurance",
          //Product Gallery ENGLISH ENDS HERE
          DATE_OF_BIRTH: "Date of Birth",
          GET_A_QUOTE_NOW: "GET A QUOTE NOW",
          CLOSE_BTN: "CLOSE",
          ODDER_N0TE: "Note: Please proceed to payment in ONEIC Counter application",
          SOMETHING_WRONG: "Note: Something went wrong.",
          // VIEW MOTOR DETAILS ENGLISH VARIABLES STARTS HERE
          VIEW_LB_APP_ID: "Application ID",
          VIEW_LB_QUOTE_ID: "Quote ID",
          VIEW_LB_CHANNEL: "Channel",
          VIEW_LB_CREATED_AT: "Created At",
          VIEW_LB_PRODUCT_NAME: "Product Name",
          VIEW_LB_SUM_INSURED: "Sum Insured",
          VIEW_LB_TOTAL_PREMIUM: "Total Premium",
          VIEW_LB_TERM: "Term",
          VIEW_LB_ORDER_STATUS: "Order Status",
          VIEW_LB_CHASSIS_NUMBER: "Chassis Number",
          VIEW_LB_ENGINE_NUMBER: "Engine Number",
          VIEW_LB_COLOR: "Color",
          VIEW_LB_MAKE: "Make",
          VIEW_LB_MODAL: "Modal",
          VIEW_LB_TRIM: "Trim",
          VIEW_LB_DOORS: "Doors",
          VIEW_LB_SEATS: "Seats",
          VIEW_LB_CLASS: "Class",
          VIEW_LB_DISPLACEMENT: "Displacement",
          VIEW_LB_MILEAGE_EST: "Mileage Est",
          VIEW_LB_PREVIOUS_EXPIRY: "Previous Expiry",
          VIEW_LB_VEHICLE_NUMBER: "Vehicle Number",
          VIEW_LB_IDV: "IDV",
          VIEW_LB_POLICY_TYPE: "Policy Type",
          VIEW_LB_REGISTRATION_TYPE: "Registration Type",
          VIEW_LB_DRIVER_NAME: "Name",
          VIEW_LB_DRIVER_AGE: "Age",
          VIEW_LB_ADDRESS: "Address",
          VIEW_LB_CIVIL_ID: "Civil Id",
          VIEW_LB_RESIDENT_ID: "Resident Id",
          VIEW_LB_BASIC_DETAILS_TITLE: "Basic Details",
          VIEW_LB_VEHICLE_DETAILS_TITLE: "Vehicle Details",
          // VIEW MOTOR DETAILS ENGLISH VARIABLES ENDS HERE
        }
      },
      ar: {
        translations: {
          WHO_WOULD_YOU_LIKE_TO_INSURANCE: "من الذي ترغب في تأمينه؟",
          "EMAIL": "رقم البريد",
          COVER: "غطاء",
          PAYMENT_TERM: "مصطلح الدفع",
          SUM_ASSURED: "المبلغ المؤمن",
          Motor: 'محرك',
          HELP: "يساعد",
          Male: 'سيء',
          Female: "أنثى",
          Gender: 'جنس',
          EDIT: 'يحرر',
          COMPARE: 'يقارن',
          Term: 'شرط',
          MODE: 'موضة',
          TOTAL: "إجمالي المساهمة",
          OCCUPATION: "المهنة",
          BANKNAME: "البنك المُصدر للقرض",
          CURRENCY: 'عملة',
          POLICY_TERM: "مصطلح السياسة",
          ANNUAL_INCOME_AED: 'الدخل السنوي (درهم)',
          CHOOSE_RIDERS: 'اختر الدراجين',
          CHECK_PRODUCT_DETAILS: "تحقق من تفاصيل المنتج",
          COVERAGE: 'تغطية',
          TERM: 'شرط',
          KNOW_MORE: 'تعرف أكثر',
          FILTER_SEARCH: 'بحث التصفية',
          FILTER: 'منقي',
          YES: 'نعم',
          NO: 'لا',
          CANCEL: 'يلغي',
          PAGE_BACK_BTN: "رجوع",
          INSURED_DETAILS: 'التفاصيل المؤمن عليها',
          CompanyName: 'اسم الشركة',
          "Company Name": "اسم الشركة",
          PLACEHOLDER_RTO_CODE: "رمز RTO",
          VerifyDetails: 'التحقق من التفاصيل',
          OtpSentToMobile: 'تم إرسال OTP إلى الهاتف المحمول',
          PREVIOUS_POLICY: 'تفاصيل السياسة السابقة/الحالية',
          REVIEW_DETAILS: "تفاصيل المراجعة",
          ADDRESS_DETAILS: "تفاصيل العنوان",
          PAY_NOW: "ادفع الآن",
          STATUS: "حالة:",
          APPROVED_BY_UNDERWRITER: "تمت الموافقة عليه من قبل المكتتب",
          PAYMENT_SUCCESSFUL: "تم الدفع بنجاح!",
          PAYMENT_FAILED: "عملية الدفع فشلت!",
          CONTINUE: "يكمل",
          ADD_FAMILY_MEMBER_BTN: "+ إضافة عضو",
          RETRY: "أعد المحاولة",
          THANK_YOU: "شكرًا لك",
          SUM_ASSURED: "المبلغ المؤمن عليه",
          TENURE: "الحيازة",
          PREMIUM: "غالي",
          ORDER_STATUS: "حالة الطلب",
          CLEAR: "واضح",
          SAVE: "يحفظ",
          SORRY: "آسف!",
          DONT_HAVE_PLANS: "ليس لدينا خطط بناءً على معاييرك.",
          GO_BACK: "عُد",
          TERMINAL_ILLNESS_BENEFIT: "منفعة المرض العضال",
          PLAN_FEATURES: "ميزات الخطة",
          WHAT_YOU_GET: "على ماذا حصلت",
          DOCUMENTS: "وثائق",
          FAQ: "التعليمات",
          FIRST_NAME: "الاسم الأول",
          MIDDLE_NAME: "الاسم الأوسط",
          LAST_NAME: "اسم العائلة",
          COUNTRY_OF_BIRTH: "بلد الميلاد",
          PASSPORT_ID_NO: "رقم جواز السفر/الهوية",
          MARITAL_STATUS: "الحالة الاجتماعية",
          NATIONALITY: "جنسية",
          BENEFICIARY_NAME: "الاسم الكامل للمستفيد",
          BENEFICIARY_MIDDLE_NAME: "الاسم الأوسط للمستفيد",
          BENEFICIARY_LAST_NAME: "الاسم الأخير للمستفيد",
          RELATIONSHIP: "علاقة",
          ALLOCATION_PER: "نسبة التخصيص",
          ASSIGNEE_ADDRESS: 'عنوان المكلف',
          GUARDIAN_NAME: "اسم الوصي الكامل",
          RELATIONSHIP_TO_BENEFICIARY: "العلاقة مع المستفيد (المستفيدين)",
          ID_PASSPORT_NO: "رقم الهوية / جواز السفر",
          UPLOAD_DOCUMENT: "تحميل الصور",
          PAYMENT_OPTION: "يرجى تحديد خيار الدفع المفضل لديك",
          STANDING_INSTRUCTION: "قم بإعداد التعليمات الدائمة والدفع التلقائي للأقساط المستقبلية تلقائيًا في مواعيد استحقاقها.",
          CASH: "نقدي",
          CREDIT_CARD: "بطاقة الخصم / الائتمان",
          AT_BRANCH: "في الفرع",
          ONLINE: "متصل",
          CHEQUE: "يفحص",
          OTHERS: "آحرون",
          ADD: "يضيف",
          ADD_RIDER: "أضف رايدر",
          DOCUMENT_UPLOAD: "تحميل الوثيقة",
          DOWNLOAD: "تحميل",
          DOWNLOADS_TITLE: "التحميلات",
          DOCUMENT_TYPE: "نوع الوثيقة",
          BROWSE: "تصفح",
          PLUS_ADD: "أضف +",
          ORDER_ID: "رقم التعريف الخاص بالطلب :",
          MEMBER: "عضو",
          TRANSACTION_ID: "رقم المعاملة :",
          REFERENCE_NO: "رقم المرجع",
          AMOUNT: "كمية",
          ADD_FAMILY_MEMBER: "إضافة فرد من العائلة +",
          FAMILY_HISTORY: "تاريخ العائلة",
          HEALTH_STATUS: "الوضع الحيوي",
          CURRENT_AGE: "العمر الحالي",
          AGE_AT_DEATH: "العمر عند الوفاة",
          CAUSE_OF_DEATH: "سبب الموت",
          STATE_OF_HEALTH: "حالة حيوية",
          ADD_FAMILY_MEMBER_MODAL: "إضافة فرد من العائلة",
          FATHER: "أب",
          MOTHER: "الأم",
          BROTHER: "أخ",
          SISTER: "أخت",
          DOWNLOAD_BENEFIT_ILLUSTRATION: "انقر هنا لتحميل الرسم التوضيحي للمنفعة",
          MIN_MAX_ENTRY_AGE: "الحد الأدنى - الحد الأقصى. سن الدخول",
          MIN_MAX_PAYMENT_TERM: "الحد الأدنى - الحد الأقصى. مصطلح الدفع",
          MIN_CONTRIBUTION: "دقيقة. مساهمة",
          MAX_LIFE_COVER: "الأعلى. غلاف الحياة",
          MIN_LIFE_COVER: "دقيقة. غلاف الحياة",
          GEOGRAPHIC_COVERAGE: "التغطية الجغرافية",
          FREE_LOOK_PERIOD: "فترة نظرة مجانية",
          GRACE_PERIOD: "فترة السماح",
          WHAT_COVERED: "ما هو الغطاء",
          WHAT_NOT_COVERED: "ما لا يغطي",
          LIFESTYLE_QUESTIONNAIRE: "استبيان نمط الحياة",
          DO_YOU_SOMKE: "هل تدخن؟",
          TOBACCO_TYPE: "نوع التبغ",
          FREQUENCY: "تكرار",
          QUANTITY: "كمية",
          ALCOHOL_TYPE: "نوع الكحول",
          FREQUENCY_FOR_ALCOHOL: "تردد للكحول",
          UNITS: "الوحدات",
          PROPOSAL_NUMBER: "رقم الاقتراح",
          ADDON_TITLE: "الإضافات",
          YES_SMOKE: "نعم أنا أدخن",
          CONSUME_ALCOHOL: "نعم، أنا أتناول الكحول",
          USING_DRUG: "هل تستخدم حاليا أي أدوية؟",
          YES_USING_DRUG: "نعم",
          ARMED_FORCE_MEMBER: "عضو في أي قوات مسلحة؟",
          YES_ARMED_FORCE_MEMBER: "نعم أنا عضو في القوة المسلحة",
          IN_2YEAR_TRAVELED_OUTSIDE: "خلال العامين الماضيين، هل سافرت خارج البلاد؟",
          YES_TRAVELD: "نعم لقد سافرت خارج البلاد",
          ANY_CONFIRMED_TRAVEL_PLAN: "في الأشهر الـ 12 المقبلة، هل لديك أي خطط سفر مؤكدة؟",
          YES_HAVE_PLAN_FOR_GOING_OUTSIDE_COUNTRY: "نعم، لدي خطط للسفر خارج البلاد",
          ENGAEGED_IN_PRIVATE_FLYING: "هل سبق لك أن شاركت في أي طيران خاص أو رياضات خطرة؟",
          YES_ENGAGED_IN_PRIVATE_FLYING: "نعم، لقد شاركت في أنشطة رياضية أو سباقات خطرة",
          WEIGHT_CHANGED: "هل تغير وزنك بأكثر من 5 كجم في العام الماضي؟",
          YES_WEIGHT_CHANGED: "نعم، لقد تغير وزني بأكثر من 5 كجم في العام الماضي",
          HAS_ANY_APPLICATION_FOR_FAMITY: "هل لديك أي من طلباتك أو تجديداتك أو إعادتك للعائلة؟",
          YES_HAS_APPLICATION: "نعم",
          HAS_ANY_INSURANCE_CLAIM: "هل قمت بتقديم أي مطالبة تكافلية/تأمين من قبلك؟",
          YES_INSURANCE_CLAIM: "نعم، تم تقديم المطالبة",
          SIGN_OUT: "خروج",
          LOGIN: "تسجيل الدخول",
          SIGNATURE: "إمضاء:",
          Employers_Name: "اسم صاحب العمل",
          TYPE_OF_BENEFICIARY: "نوع المستفيد",
          NOT_SURE_GET_OUR_RECOMMENDATION: "غير متأكد؟ احصل على توصيتنا بشأن احتياجاتك التأمينية",
          LANDING_BACK: "خلف",
          DETAILS_OF_TOTAL_LIABILITIES: "تفاصيل إجمالي المطلوباتS",
          SOURCE_OF_FUND_INVESTED: "مصادر الأموال المراد استثمارها",
          ACCOUNT_DETAILS: "تفاصيل الحساب",
          REALESTATE: "العقارات",
          STOCKS_AND_BONDS: 'الاسهم والسندات',
          EMIRATESID: "هويه الإمارات",
          FULLNAME: "الاسم الكامل",
          YOU_DO_NOT_HAVE_ANY_PREVIOUS_POLICY: "ليس لديك أي سياسة سابقة",
          PRE_EXISTING_DISEASES_DECLARED: "تم الإعلان عن الأمراض الموجودة مسبقًا.",
          NOT_SUFFERING_FROM_ANY_DISEASE: "عدم المعاناة من أي مرض",
          YOU_HAVE_NOT_DECLARED_ANY_LIFESTYLE_CONDITIONS: "لم تعلن عن أي شروط نمط الحياة",
          TOTAL_ASSETS: "تفاصيل إجمالي الأصول:",
          TOTAL_LIABILITIES: "اجمالي المطلوبات:",
          DEBT_ACCOUNT: "حساب الدين:",
          FOR_FURTHER_QUERIES_AND_ASSISTANCE: "لمزيد من الاستفسارات والمساعدة",
          FATCA_AND_CRS_DATA: "بيانات قانون الامتثال الضريبي للحسابات الأجنبية (FATCA) والمعايير الموحدة للإبلاغ الضريبي (CRS).",
          HEALTH_QUESTIONAAIRE: "استبيان الصحة والسفر",
          FATCA_and_CRS: "قانون الالتزام الضريبي للحسابات الأجنبية (FATCA) والمعيار المشترك للإبلاغ الضريبي (CRS).",
          GO_TO_MY_ACCOUNT: "اذهب إلى حسابي",
          GO_TO_MY_DASHBOARD: "اذهب إلى لوحة القيادة",
          GO_TO_HOME: "اذهب إلى المنزل",
          SUCCESS: "نجاح!",
          SUCCESSFULLY_SUBMITTED: "لقد تم إرسال طلب المصادقة الخاص بك بنجاح.",
          HOME: "بيت",
          YOU_CAN_ALSO_CHECK_THE_PROPOSAL_STATIS_IN_YOUR_ACCOUNT: "يمكنك أيضًا التحقق من حالة الاقتراح في حسابك.",
          BROCHURES: "كتيبات",
          DOCUMENT_BROCHURE_TXT: "كتيب",
          CLAIM_FORMS: "نماذج المطالبة",
          SERVICING_FORMS: "نماذج الخدمة",
          OTHER_DOCUMENTS: "وثائق أخرى",
          QUESTIONNAIRE: "استبيان",
          LIFE_PURE_PROTECTION: "حماية الحياة النقية",
          CHANGE_OF_ADDRESS_FORM: "نموذج تغيير العنوان",
          DEATH_CLAIM_FORM_A_CLAIMANT_STATEMENT_RB: "مطالبة الوفاة - قم بتكوين بيان المطالبة RB",
          DEATH_CLAIM_FORM_B_ATTENDING_PHYSICIANS_STATEMENT: "مطالبة الوفاة - نموذج ب إفادة الطبيب المعالج",
          DEATH_CLAIM_FORM_C_EMPLOYER_STATEMENT: "مطالبة الوفاة - نموذج ج بيان صاحب العمل",
          LIFE_SMART_SAVE: "إنقاذ الحياة الذكية",
          PROPOSER_DONE: "مقدم العرض (تم)",
          LIFE_ASSURED_DONE: "المؤمن عليه / المؤمن عليه (تم)",
          WITHNESS_DONE: "شاهد (تم)",
          AGENT_DONE: "الوكيل (تم)",
          PLEASE_ADD_SIGNATURE: "الرجاء إضافة التوقيعات من",
          INSURED: "المؤمن عليه",
          CLICK_HERE_TO_EDIT: "انقر هنا لإعادة التوقيع",
          PROPOSER: "مقترح",
          LIFE_ASSURED_INSURED: "المؤمن عليه / المؤمن عليه",
          LIFE_ASSURED_INSURED2: "2 المؤمن عليه / المؤمن عليه",
          WITNESS: "شاهد",
          AGENT_SIGNATURE: "توقيع الوكيل",
          SURE_TO_SUBMIT_PROPOSER: "هل أنت متأكد أنك ترغب في تقديم الاقتراح؟",
          PLEASE_NOTE_AFTER_SUBMISSION_YOU_CANNOT_EDIT: "يرجى ملاحظة أنه لا يمكنك إجراء تعديلات على النموذج بعد الإرسال.",
          Share_The_Link: "مشاركة الرابط مع العميل",
          GO_TO_DASHBOARD: "اذهب إلى لوحة القيادة الخاصة بي",
          Link_successfully: "تمت مشاركة الرابط بنجاح مع العميل",
          AGENT_CODE: "رمز العميل",
          ENTER_YOUR_AGENT_CODE_FOR_REFERRAL_COMMISSION: "أدخل رمز الوكيل والفرع الخاص بك للحصول على عمولة الإحالة",
          YES_PROCEEE: "نعم، تابع",
          NO_CANCEL: "لا، إلغاء",
          AGGENT_CHECK_ONE_DECS: "أقر أنني التقيت/تحدثت مع العميل وشرحت له كافة محتويات نموذج العرض هذا، بما في ذلك طبيعة الأسئلة الواردة في نموذج العرض هذا باللغة العامية المعروفة له/لها ويتم بيع السياسة بما يتماشى مع أسلوبه/لغته. متطلباتها.",
          AGGENT_CHECK_TWO_DECS: "لقد أوضحت أيضًا أن البيان (البيانات) والمعلومات والردود (الإجابات) المقدمة منه/ها في نموذج الاقتراح هذا على الأسئلة الواردة هنا أو أي تفاصيل مطلوبة هنا ستشكل أساس عقد التأمين بين الشركة ومقدم الطلب ، إذا تم قبول هذا الاقتراح من قبل الشركة لإصدار السياسة. أنا راضٍ عن هوية هذا الاحتمال (التوقعات) وأوصي بالنظر في المعلومات المذكورة أعلاه بشأن الاحتمال (التوقعات) من قبل الشركة.",
          AGGENT_CHECK_THREE_DECS: "أنا، فينكي إميدي، الرمز SP 00005 (الوطنية تكافل)، أوافق على أنني قرأت نموذج الطلب، وأؤكد بموجب هذا المعلومات وأرسلها أعلاه. علاوة على ذلك، فإنني أفهم وأؤكد الالتزام بالخضوع.",
          MY_ACCOUNT: "حسابي",
          MY_DASHBOARD: "لوحة القيادة الخاصة بي",
          CHANGE_SUM_ASSURED: "تغيير المبلغ مضمون",
          EXISTING_SUM_ASSURED: "المبلغ المضمون الحالي",
          UPDATED_CONTRIBUTION: "مساهمة محدثة",
          PREVIOUS_CURRENT_ADDRESS: "العنوان الحالي السابق",
          PREVIOUS_PERMANENT_ADDRESS: "العنوان الدائم السابق",
          CANCEL_POLICY: "إلغاء السياسة",
          FREE_LOOK_CANCELLATION: "إلغاء النظرة المجانية",
          REINSTATE_POLICY: "إعادة السياسة",
          PAYMENT_DUE: "الدفع مستحق",
          CONTRIBUTION_ID: "معرف المساهمة",
          TOTAL_PREMIUM_CONTRIBUTION_DUE: "إجمالي مساهمة الأقساط المستحقة",
          DUE_DATE: "تاريخ الاستحقاق",
          YOU_HAVE_NOT_DECLARED_ANY_HEALTH_TRAVEL_CONDITIONS: 'لم يتم الإعلان عن أي ظروف صحية وسفر',
          TRAVEL_DETAILS: 'معلومات السفر',
          NAME_OF_COUNTRY: 'اسم البلد',
          DATE_DEPARTED: 'تاريخ الرحيل',
          DATE_ARRIVED: 'تاريخ الوصول',
          REASON_FOR_TRAVEL: 'سبب السفر',
          NAME_OF_THE_BANK: "اسم البنك",
          ACCOUNT_NUMBER: "رقم الحساب",
          ACCOUNT_NAME: "إسم الحساب",
          IBAN_NUMBER: "رمز سويفت/رقم الحساب المصرفي الدولي.",
          BANK_ADDRESS: "عنوان البنك",
          ARMED_FORCES_QUESTIONNAIRE: "استبيان القوات المسلحة",
          FINANCIAL_QUESTIONNAIRE: "الاستبيان المالي",
          OVERSEAS_TRAVEL_AND_RESIDENCE_QUESTIONNAIRE: "استبيان السفر والإقامة في الخارج",
          CHEST_PAIN_QUESTIONNAIRE: "استبيان ألم الصدر",
          DIABETES_MELLITUS_QUESTIONNAIRE: "استبيان حول مرض السكري",
          KEYMAN_AND_BUSINESS_COVER_QUESTIONNAIRE: "استبيان Keyman وتغطية الأعمال",
          FATCA_KYC_FORM_US_NATIONAL: "قانون FATCA KYC من مواطن أمريكي",
          STATEMENT_OF_GOOD_HEALTH: "بيان الصحة الجيدة",
          W9_FORM: "W9 Form",
          CONFIRM_QUOTATION: "تأكيد الاقتباس",
          CONFIRM_QUOTATION_MESS: "هل أنت متأكد أنك تريد قبول هذا الاقتباس؟ يمكنك إما تأكيد عرض الأسعار لمتابعة الاقتراح أو تعديل عرض الأسعار.",
          ACCEPT_BUTTON: "يقبل",
          MODIFY_BUTTON: "يُعدِّل",
          DECLARATION_BENEFIT_ILLUSTRATION: "إعلان - توضيح المنفعة",
          DECLARATION_DESCRIPTION_TXT: "أدرك أن الرسم التوضيحي للمزايا هو لأغراض توضيحية فقط ولا يشكل عقدًا أو عرضًا لبيع التأمين. وأدرك أيضًا أنه سيتم تحديد الشروط النهائية للبوليصة بناءً على عقد البوليصة الفعلي الصادر عن شركة التأمين. بقبول هذا الإعلان، أؤكد أنني قرأت الشروط المذكورة هنا وفهمتها وأوافق على الالتزام بها.",
          OTHER_OCCUPATION: 'اسم المهنة',
          CHOOSE_FUNDS_TITLE: "اختر الصناديق",
          FUND_ALLOCATION_TITLE: "مساهمة",
          PremiumContribution: "مساهمة",
          CREDIT_DISCLAIMER: "أنا، حامل البطاقة المسمى أدناه، أوافق على دفع جميع المساهمات المتعلقة بهذا الاقتراح والمدفوعات اللاحقة بالتردد المذكور هنا والتي سيتم إجراؤها من خلال بطاقة الائتمان الخاصة بي.",
          ALLOWED_DISCLAIMER: "**مسموح به لحامل البطاقة وزوجه ووالديه و/أو مساهمة الأبناء فقط",
          DISCLAIMER_ERROR: "يرجى قبول الإعلان",
          DOWNLOAD_PERFORMANCE_SHEET: "تنزيل ورقة الأداء",
          INVEST_FOR: "استثمر من أجل",
          TOTAL_FUND_ALLOCATION: "إجمالي تخصيص الصندوق",
          FUND_ALLOCATION: "تخصيص الأموال (%)",
          LAST_UPDATED: "آخر تحديث لـ NAV",
          FUND_CATEGORY: "فئة الصندوق",
          BANK_NAME: "اسم البنك",
          ACCOUNT_TYPE: "نوعالحساب",
          ACCOUNT_CURRENCY_TYPE: "نوع عملة الحساب",
          FIRST_YEAR_INCOME: "دخل السنة الأولى",
          SECOND_YEAR_INCOME: "دخل السنة الثانية",
          THIRD_YEAR_INCOME: "دخل السنة الثالثة",
          SHORT_TERM_LOANS: "قروض قصيرة الأجل",
          LONG_TERM_LOANS: "قروض قصيرة الأجل",
          OTHER_LOANS: "قروض أخرىs",
          TOTAL_LIABILITIES: "إجمالي الالتزامات",
          YOU_DONT_HAVE_ANY_PREVIOUS_POLICY: "ليس لديك أي سياسة سابقة",
          YOUR_CUSTOMER_DOESNT_HAVE_ANY_PREVIOUS_POLICIES: "ليس لدى عميلك أي سياسات سابقة.",
          // HOME PAGE ARABIC STARTS HERE
          HM_ONIC_GROUP_COMPANY: "مجموعة شركات أونك",
          HM_GET_INSURANCE_STEPS: "احصل على الخاص بكالتأمين في 3 خطوات سهلة",
          HM_MORE: "أكثر",
          HM_SAVINGS: "الادخار",
          HM_MORE_CONVENIENCE_TXT: "والمزيد من الراحة لك!",
          HM_START_YOUR_JOURNEY: "ابدأ رحلتك",
          HM_PROVIDE_US_THE_DETAILS_TXT: "تقدم لنا تفاصيل للتأمين و اترك الباقي لنا.",
          HM_COMPARE_CHOOSE: "قارن واختر",
          HM_WE_BRING_THE_BEST_TXT: "نقدم لك أفضل تأمين عبر الإنترنت للمقارنة والاختيار",
          HM_BUY_SAVE: "شراء وحفظ",
          HM_FAST_POLICY_INSURANCE: "إصدار سريع للسياسة لحفظ الخاص بك الوقت والمال.",
          HM_REQUEST_CALL_BUTTON: "طلب معاودة الاتصال",
          HM_INSURANCE_PARTNER_TXT: "شركاؤنا في التأمين",

          // MOTOR ARABIC LANGUAGE KEYS STARTS HERE 
          GREAT: "عظيم",
          CHOICE: "خيار!",
          NOW_ENTER_YOUR_DETAILS: "الآن أدخل التفاصيل الخاصة بك",
          ENTER_YOUR_CAR_OR_MOTORCYCLE_PLATE_NUMBER: "خطط لرحلتك القادمة بدون أي قلق",
          ENTER_DRIVER_DETAILS: "أدخل تفاصيل السائق...",
          NAME: "* اسم",
          ENTER_YOUR_MOBILE_NUMBER: "أدخل رقم هاتفك المحمول",
          MOBILE_NUMBER: "رقم الهاتف المحمول",
          POLICY_TYPE_LABEL_TXT: "نوع السياسة",
          NEW_CAR_CONTINUE_WITHOUT_CAR_NUMBER: "سيارة جديدة؟ الاستمرار بدون رقم السيارة",
          NOT_A_NEW_CAR: "ليست سيارة جديدة؟",
          GET_MOTOR: "احصل على المحرك",
          OFFERS: "العروض",
          WHICH_PLAN_ARE_YOU_LOOKING_FOR: "ما هي الخطة التي تبحث عنها؟",
          BUY: "يشتري",
          THIRD_PARTY: "طرف ثالث",
          COMPREHENSIVE: "شامل",
          HOME_BUTTON_THIRD_PARTY: "طرف ثالث",
          HOME_BUTTON_COMPREHENSIVE: "شامل",
          WHAT_IS_THE_DIFFERENCE_BETWEEN_THIRD_PARTY_AND_COMPREHENSIVE_INSURANCE: "ما الفرق بين تأمين الطرف الثالث والتأمين الشامل؟",
          WHAT_IS_YOUR_VEHICLE_VALUE: "ما هي قيمة سيارتك؟",
          ENSURE_ACCURATE_COVERAGE_FOR_YOUR_CAR: "ما هي قيمة سيارتك؟",
          YES_PROCEED: "نعم تابع",
          CONFIRM_YOUR: "تأكيد الخاص بك",
          VALUE_IN_RO: "القيمة بالريال العماني",
          MAKE_SURE_THE_CAR_VALUE_YOU_ENTERED_MATCHES_THE_MARKET_PRICE_OR_BASED_ON_THE_PREVIOUS_POLICY: "تأكد من أن قيمة السيارة التي أدخلتها تتطابق مع سعر السوق أو أقل بنسبة 10 - 15% من قيمة السيارة المنتهية \ قيمة وثيقة التأمين للسنة الماضية",
          COMPREHENSIVE: "شامل",
          VEHICLE_VALUE: "قيمة المركبة :",
          BUY_NOW: "اشتري الآن",
          MOTOR_VIEW_BREAKUP: "عرض الانفصال",
          YOUR_NEW_POLICY_WILL_START_ON: "ستبدأ سياستك الجديدة في",
          LANDING_GET_EASY_SUB_TXT: 'احصل على تأمين سهل وسريع وقارن بين العروض المختلفة المقدمة من مقدمي خدمات مختلفين',
          LANDING_CARDS_MOTOR_INSURANCE_TITLE: 'التأمين على السيارات',
          LANDING_CARDS_CREDIT_INSURANCE_TITLE: "التأمين على الحياة الائتمانية",
          LANDING_CARDS_TRAVEL_DOMESTIC_INSURANCE_TITLE: "تأمين العمالة المنزلية",
          LANDING_PAGE_TITLE_NEW_AGE_PARTNER: 'شريك العصر الجديد لكل ما تبذلونه من',
          LANDING_PAGE_TITLE_INSURANCE: "تأمين",
          LANDING_PAGE_TITLE_NEEDS_TXT: 'الاحتياجات',
          HELP_MODAL_SUPPORT_EMAIL: "support@tameen.om",
          MODAL_SUPPORT_NUMBER: "+968 2223456",
          ADDON_TYPE_LABEL: "يكتب",
          ADDON_LEFT_LABEL: "الملحق",
          ADDON_ADD_BUTTON: "يضيف",
          ADDON_REMOVE_BUTTON: "يزيل",
          ADDITIONAL_DRIVERS: "برامج تشغيل إضافية",
          MOTOR_ADD_VEHICLE_OWNERS_NAME: "إضافة اسم مالك المركبة",
          VEHICLE_DETAILS: "تفاصيل السيارة",
          DRIVER_DETAILS: "تفاصيل السائق",
          SUMMARY_AGE_LABEL: "عمر",
          SUMMARY_TOTAL_AMOUNT_RO: "المبلغ الإجمالي ريال عماني",
          ODDER_N0TE: "ملحوظة: يرجى التوجه إلى الدفع في تطبيق ONEIC Counter",
          SOMETHING_WRONG: "ملاحظة: حدث خطأ ما",
          SUMMARY_ORDERID: "معرف الطلب",
          SUMMARY_BY_CONTINUING_YOU_AGREE_TO_OUR: "من خلال الاستمرار فإنك توافق على لدينا",
          SUMMARY_TERMS_CONDITIONS: "الشروط والأحكام",
          SUMMARY_PROPOSAL_FORM: "نموذج الاقتراح",
          SUMMARY_DOCUMENT_1_LABEL: "وثيقة - 1",
          SUMMARY_DOCUMENT_2_LABEL: "وثيقة - 2",
          SUMMARY_DOCUMENT_3_LABEL: "وثيقة - 3",
          FULL_NAME_OF_VEHICLE_OWNER: "الاسم الكامل لصاحب السيارة",
          LICENSE_NUMBER: "رقم الترخيص",
          QUICK_TIP: "نصيحة سريعة",
          QUICK_TIP_DEC: "إضافة برامج تشغيل إضافية إلى الوثيقة ليس إلزاميا، وخصم 25 ريال عماني عند فتح نموذج المطالبة فقط.",
          MOTOR_PLEASE_SELECT_DRIVER_OR_ADD_NEW_DRIVER: "الرجاء تحديد برنامج التشغيل أو إضافة برنامج تشغيل جديد",
          ENTER_YOUR_NAME: "أدخل اسمك",
          ENTER_YEARS: "أدخل السنوات",
          SELECT_BUTTON_TXT: "يختار",
          RADIO_BUTTON_YES: "نعم",
          RADIO_BUTTON_NO: "لا",
          PLACEHOLDER_CHARS: "رمز RTO",
          PLACEHOLDER_BAISIC_FORM_VEHICLE_NUMBER: "رقم لوحة الدراجة النارية",
          PLACEHOLDER_CODE: "شفرة",
          PLACEHOLDER_YEAR: "سنة",
          RE_SEND_OTP: "إعادة إرسال كلمة المرور لمرة واحدة",
          RE_SEND_OTP_MSG: "إعادة الإرسال في 00:",
          OTP_MOBILE_VERIFICATION_TITLE: "تَحَقّق",
          OTP_MOBILE_TITLE_SUB_TXT: "أدخل كلمة المرور لمرة واحدة (OTP) المستلمة على هاتفك المحمول.",
          YOUR_CAR_TITLE: "سيارتك",
          DETAILS_TITLE: "تفاصيل",
          BEST_DEALS_VALUE_TXT: "قيمة",
          BEST_DEALS_ADDON_TITLE: "إضافة إضافات",
          TRY_AGAIN: "حاول ثانية",
          MOTOR_PAYMENT_SUCCESSFUL_MSG_TXT: "شكرًا لك! لقد تم استلام دفعتك البالغة 2500 ريال عماني.",
          MOTOR_PAYMENT_CONTACT_MSG_TXT: "يرجى الاتصال بنا على XXX- XXXXXX أو إرسال بريد إلكتروني إلى",
          MOTOR_PAYMENT_EMAIL_TXT: "help@tameen.om",
          MOTOR_PAYMENT_CONTACT_QUERY_TXT: "لأي استفسار.",
          MOTOR_PAYMENT_FAILED_TITLE_TXT: "فشل الدفع!",
          MOTOR_PAYMENT_FAILED_MSG_TXT: "حدث خطأ أثناء معالجة دفعتك. يرجى المحاولة مرة أخرى",
          MOTOR_RETRY_PAYMENT_BUTTON: "إعادة محاولة الدفع",
          BASIC_FROM_PROCEED_BTN: 'يتابع',
          PAY_PROCEED_BTN: 'يتابع',
          SM_HOME: "بيت",
          SM_ABOUT_US: "معلومات عنا",
          SM_WHAT_WE_ARE: "ما نحن عليه",
          SM_OUT_TEAM: "فريقنا",
          SM_CONTACT_US: "اتصل بنا",
          SM_FAQS: "الأسئلة الشائعة",
          SM_PRIVACY_POLICY: "سياسة الخصوصية",
          SM_TERMS_AND_CONDITIONS: "الشروط والأحكام",
          SM_ACC_PERSONAL_INSURANCE_HD_TXT: "التأمين الشخصي",
          SM_ACC_MOTOR_INSURANCE: "التأمين على السيارات",
          SM_ACC_TRAVEL_INSURANCE: "تأمين السفر",
          SM_ACC_HEALTH_INSURANCE: "التأمين الصحي",
          SM_ACC_HOME_INSURANCE: "التأمين على المنزل",
          SM_ACC_HOUSEMAID_INSURANCE: "تأمين الخادمة المنزلية",
          SM_ACC_PERSONAL_ACCIDENT_INSURANCE: "التأمين ضد الحوادث الشخصية",
          SM_ACC_GOLF_INSURANCE: "تأمين الجولف",
          SM_ACC_LIFE_INSURANCE: "التأمين على الحياة",
          SM_ACC_GROUP_EMPLOYEE_INSURANCE_HD_TXT: "تأمين المجموعة/الموظفين",
          SM_ACC_COMMERCIAL_INSURANCE_HD_TXT: "التأمين التجاري",
          SM_ACC_SPECIALIZED_INSURANCE_HD_TXT: "التأمين المتخصص",
          SM_ACC_INSURANCE_SERVICES_HD_TXT: "خدمات التأمين",

          // TRAVEL HERE
          FLOAT_TRAVELLING_FROM: "السفر من",
          FLOAT_TRAVELLING_TO: "السفر الى",
          SUMMARY_CONTINUE_PAYMENT_BTN: "الاستمرار في الدفع",

          //FAQ HERE
          FAQ_MOTOR_INSURANCE_PAGE_HEADING: "التأمين على السيارات",
          FAQ_TRAVEL_INSURANCE_PAGE_HEADING: "تأمين السفر",
          FAQ_HOME_INSURANCE_PAGE_HEADING: "التأمين على المنزل",
          FAQ_LIFE_INSURANCE_PAGE_HEADING: "التأمين على الحياة",
          FAQ_MEDICAL_INSURANCE_PAGE_HEADING: "التأمين الطبي",
          FAQ_PROPERTY_INSURANCE_PAGE_HEADING: "التأمين على الممتلكات",

          //CLAIM ASSISTANCE 
          CLAIM_ASSISTANCE_BANNER_HEADING: "مساعدة المطالبات من خلال تأمين.وم",
          CLAIM_PROCESS_ROADSIDE_ASSISTANCE: "المساعدة على الطريق",
          CLAIM_PROCESS_CUSTOMER_CARE_NO_TITLE: "رقم خدمة العملاء",
          CLAIM_PROCESS_CLAIMS_REGISTRATION_NO: "رقم تسجيل المطالبات",
          CLAIM_PROCESS_MAIL_ID: "معرف البريد",
          CLAIM_PROCESS_ONLINE: "المطالبات عبر الإنترنت",
          CLAIM_PROCESS_CLAIM_INTIMATION: "إخطار المطالبة",
          CLAIM_PROCESS_CLAIM_PROCESSING: "معالجة المطالبة",
          CLAIM_PROCESS_CLAIM_SETTLEMENT: "تسوية المطالبة",
          CLAIM_PROCESS_DOCUMENTS_REQUIRED: "المستندات المطلوبة",
          CLAIM_PROCESS_DROP_OFF: "التوصيل",
          CLAIM_PROCESS_REPAIR_ESTIMATE: "تقدير الإصلاح",
          CLAIM_PROCESS_VEHICLE_INSPECTION: "فحص المركبة",
          CLAIM_PROCESS_REPAIR_WORKS: "أعمال الإصلاح",
          CLAIM_PROCESS_WHATSAPP_NO: "رقم تواصل واتس اب",
          CLAIM_PROCESS_OTHERS: "أرقام تواصل اخرى",
          PLEASE_SELECT_INSURER_CNT_DETAILS: "يرجى اختيار شركة التأمين للحصول على تفاصيل الاتصال",
          CLAIM_PROCESS_NOTE_TXT: "ملحوظة:",
          DWN_CLAIM_FROM_BTN: "تحميل نموذج المطالبة",

          //MOTOR CLAIM PROCESS
          MOTOR_CLAIM_PROCESS_HEADING: "عملية المطالبة بالسيارات",
          MOTOR_CLAIM_DWN_CLAIM_FROM: "تحميل نموذج المطالبة بالمركبة",

          // TRAVEL CLAIM PROCESS
          TRAVEL_CLAIM_PROCESS_HEADING: "عملية المطالبة بالسفر",
          TRAVEL_CLAIM_DWN_CLAIM_FROM: "DOWNLOAD TRAVEL CLAIM FORM",

          // MEDICAL CLAIM PROCESS
          MEDICAL_CLAIM_PROCESS_HEADING: "إجراءات المطالبات الطبية",
          MEDICAL_CLAIM_DWN_CLAIM_FROM: "عملية مطالبات التأمين الطبي",

          civilId: "الهوية المدنية",
          licenseID: "رقم الليسن",


          // Commercial Insurance Arabic Starts Here
          COMM_INSU_BANNER_TITLE: "التأمين التجاري",
          COMM_INSU_BANNER_REQUES_CALL_BACK_BTN: "طلب معاودة الاتصال",
          COMM_INSU_GET_QUOTES_BTN: "إحصل على عروض الأسعار",
          //commercial Insurance Arabic Ends Here

          // HEADER ARABIC STARTS HERE
          HEADER_SLOG_TEXT: "إنقر - قارن - وفر",
          // HEADER ENGLISH ENDS HERE

          //Product Gallery ARABIC STARTS HERE
          YACHT_INSURANCE: "تأمين اليخوت",
          ART_INSURANCE: "التأمين على الأعمال الفنية",
          RELOCATION_INSURANCE: "تأمين النقل",
          GOLF_INSURANCE: "التأمين على الجولف",
          PRODUCT_GALLERY_PROJECT_INSU_TXT: "تأمين المشاريع",
          PRODUCT_GALLERY_BUSINESS_GROUP_POLICY_INSU_TXT: "تأمين مجموعة الأعمال التجارية",
          PRODUCT_GALLERY_GROUP_LIFE_INSU_TXT: "التأمين الجماعي على الحياة",
          PRODUCT_GALLERY_TERRORISM_POLITICAL_INSU_TXT: "التأمين ضد مخاطر الإرهاب والمخاطر السياسية",
          PRODUCT_GALLERY_CYBER_CRIME_INSU_TXT: "التأمين ضد الجرائم الإلكترونية",
          PRODUCT_GALLERY_ENGINEERIGN_INSU_TXT: "التأمين الهندسي",
          PRODUCT_GALLERY_STOCK_THROUGHPUT_COVER_INSU_TXT: "التأمين على إنتاجية المخزون",
          PRODUCT_GALLERY_JEWELERS_BLOCK_INSU_TXT: "التأمين على المجوهرات",
          PRODUCT_GALLERY_WORKMEN_COMPENSATION_INSU_TXT: "تأمين تعويضات العمال",
          PRODUCT_GALLERY_SPECIALTY_RISK_EVENT_INSU_TXT: "تأمين الأحداث ذات الاحداث الخاصة أو المتخصصة",
          PRODUCT_GALLERY_GROUP_PERSONAL_ACCITENT_INSU_TXT: "التأمين ضد الحوادث الشخصية الجماعية",
          PRODUCT_GALLERY_PROPERTY_INSU_TXT: "التأمين على الممتلكات",
          PRODUCT_GALLERY_GROUP_HEALTH_INSU_TXT: "التأمين الصحي الجماعي",
          PRODUCT_GALLERY_FIDELITY_GUARANTEE_INSU_TXT: "الأمانة - الضمان - التأمين",
          PRODUCT_GALLERY_BURGLARY_INSU_TXT: "التأمين ضد السرقة",
          PRODUCT_GALLERY_LIABILITY_INSU_TXT: "التأمين على المسؤولية",
          PRODUCT_GALLERY_MARINE_INSU_TXT: "التأمين البحري",
          PRODUCT_GALLERY_HAULIERS_FULL_VALUE_CARTO_INSU_TXT: "تأمين البضائع الناقلة بالقيمة الكاملة للشحنات",
          PRODUCT_GALLERY_MOTOR_FLEET_INSU_TXT: "تأمين أسطول السيارات",
          PRODUCT_GALLERY_ENERGY_INSU_TXT: "التأمين على الطاقة",
          //Product Gallery ARABIC ENDS HERE
          DATE_OF_BIRTH: "تاريخ الميلاد",
          GET_A_QUOTE_NOW: "احصل على السعر الآن",
          CLOSE_BTN: "إغلاق",
          // VIEW MOTOR DETAILS ENGLISH VARIABLES STARTS HERE
          VIEW_LB_APP_ID: "Application ID",
          VIEW_LB_QUOTE_ID: "Quote ID",
          VIEW_LB_CHANNEL: "Channel",
          VIEW_LB_CREATED_AT: "Created At",
          VIEW_LB_PRODUCT_NAME: "Product Name",
          VIEW_LB_SUM_INSURED: "Sum Insured",
          VIEW_LB_TOTAL_PREMIUM: "Total Premium",
          VIEW_LB_TERM: "Term",
          VIEW_LB_ORDER_STATUS: "Order Status",
          VIEW_LB_CHASSIS_NUMBER: "Chassis Number",
          VIEW_LB_ENGINE_NUMBER: "Engine Number",
          VIEW_LB_COLOR: "Color",
          VIEW_LB_MAKE: "Make",
          VIEW_LB_MODAL: "Modal",
          VIEW_LB_TRIM: "Trim",
          VIEW_LB_DOORS: "Doors",
          VIEW_LB_SEATS: "Seats",
          VIEW_LB_CLASS: "Class",
          VIEW_LB_DISPLACEMENT: "Displacement",
          VIEW_LB_MILEAGE_EST: "Mileage Est",
          VIEW_LB_PREVIOUS_EXPIRY: "Previous Expiry",
          VIEW_LB_VEHICLE_NUMBER: "Vehicle Number",
          VIEW_LB_IDV: "IDV",
          VIEW_LB_POLICY_TYPE: "Policy Type",
          VIEW_LB_REGISTRATION_TYPE: "نوع التسجيل",
          VIEW_LB_DRIVER_NAME: "Name",
          VIEW_LB_DRIVER_AGE: "Age",
          VIEW_LB_ADDRESS: "Address",
          VIEW_LB_CIVIL_ID: "Civil Id",
          VIEW_LB_RESIDENT_ID: "Resident Id",
          VIEW_LB_BASIC_DETAILS_TITLE: "Basic Details",
          VIEW_LB_VEHICLE_DETAILS_TITLE: "Vehicle Details",
          // VIEW MOTOR DETAILS ENGLISH VARIABLES ENDS HERE
        }
      }
    },
    fallbackLng: "en",
    debug: true,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
